module.exports={author:"Aja Moore",date:"10/01/2019",publishDate:"10/01/2019",highlighted:!1,tags:"",title:"TGIF"};